import React from 'react';
import LoanTotalsSC from './loan-totals.styled';
import { BodyText, SmallText, HeadingTwo, BiggerText } from '../../typography';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import numeral from 'numeral';
import Moment from 'react-moment';

const LoanTotals = ({ investment }) => {
  return (
    <LoanTotalsSC>
      <div className="top-wrap">
        <BodyText className="grey">
          <FormattedMessage
            id="investor_loan_detail_totals_headline"
            defaultMessage={dlt['investor_loan_detail_totals_headline']}
          />
        </BodyText>
        <HeadingTwo className="white bold">
          {numeral(Number(investment.amount)).format('0,00.00')} €
        </HeadingTwo>
      </div>

      <div className="bottom-wrap">
        <div className="bottom-wrap--half">
          <SmallText className="black-transparent-lighter bolder">
            <FormattedMessage
              id="investor_loan_detail_totals_exposure"
              defaultMessage={dlt['investor_loan_detail_totals_exposure']}
            />
          </SmallText>
          <BiggerText>
            <Moment parse="DD.MM.YYYY" format="DD. MMMM">
              {investment.loanDueAt}
            </Moment>

            <br />
            <b>
              <Moment parse="DD.MM.YYYY" format="YYYY">
                {investment.loanDueAt}
              </Moment>
            </b>
          </BiggerText>
        </div>
        <div className="bottom-wrap--half">
          <SmallText className="black-transparent-lighter bolder">
            <FormattedMessage
              id="investor_loan_detail_totals_due"
              defaultMessage={dlt['investor_loan_detail_totals_due']}
            />
          </SmallText>
          <BiggerText>
            {investment.investor.schedules.length > 0 ? (
              <Moment parse="DD.MM.YYYY" format="DD. MMMM">
                {investment.investor.schedules[investment.investor.schedules.length - 1][1]}
              </Moment>
            ) : (
              '-'
            )}

            <br />
            <b>
              {investment.investor.schedules.length > 0 ? (
                <Moment parse="DD.MM.YYYY" format="YYYY">
                  {investment.investor.schedules[investment.investor.schedules.length - 1][1]}
                </Moment>
              ) : null}
            </b>
          </BiggerText>
        </div>
      </div>
    </LoanTotalsSC>
  );
};

export default LoanTotals;
